import React, { FormEvent } from 'react';
import styles from './NewAuthPageLayout.module.scss';
import logo from './Op.svg?url';
import available from 'src/assets/img/available-now.svg?url';
import Button from '../button/Button';
import { LordIcon } from '../lord-icon/lord-icon';

type Common = {
  children: React.ReactNode | any;
  title: React.ReactNode;
  loading: boolean;
  buttonTitle: string;
  onSubmit: (e: FormEvent) => void;
  backToLogin?: boolean;
  isParentAuth?: boolean;
  isRegistration?: boolean;
  disableLogin?: boolean;
  isSuccessful?: boolean
}

type WithRender = {
  children: () => React.ReactNode;
}

type Props = Common | WithRender;

function NewAuthPageLayout(props: Props) {
  const { children } = props;
  const { title, isRegistration, onSubmit } = props as Common;

  const handleOpenMore = () => {
    window.open('https://openparachuteschools.com/finding-the-words/', '_blank');
  }

  return (
    <div className={isRegistration ? styles.registerPage : styles.page}>
      <div className={isRegistration ? styles.backBlur : styles.hidden}></div>
      <div className={styles.left}>
      {isRegistration ? 
        <div className={styles.registerLeftContent}>
          <div className={styles.bodyContainer}>
          <h1 className={styles.registerTitle}>Teach Mental Health skills using Authentic Peer voices.</h1>
          </div>
        </div> : <div className={styles.leftContent}>
          <div className={styles.bodyContainer}>
            <div className={styles.textBody}>
              <h1 className={styles.title}>A Handbook to Support Educators</h1>
              <h5 className={styles.description}>
                A step-by-step guide to managing student reactions in the classroom.
              </h5>
              <div className={styles.subDescription} style={{marginBottom: '10px'}}><strong>#1 Best Seller on Amazon in:</strong></div>
              <div className={styles.subDescription}>
                <span className={styles.awardItem}>
                  <LordIcon src="https://cdn.lordicon.com/djpzqlgv.json" trigger="hover" size={16} colors={{primary: '#FFB073', secondary: '#FFB073'}} />
                  <span>Educational Counseling Textbooks</span>
                </span>
              </div>
              <div className={styles.subDescription}>
                <span className={styles.awardItem}>
                  <LordIcon src="https://cdn.lordicon.com/djpzqlgv.json" trigger="hover" size={16} colors={{primary: '#FFB073', secondary: '#FFB073'}} />
                  <span>School Superintendents & Principals</span>
                </span>
              </div>
              <div className={styles.subDescription}>
                <span className={styles.awardItem}>
                  <LordIcon src="https://cdn.lordicon.com/djpzqlgv.json" trigger="hover" size={16} colors={{primary: '#FFB073', secondary: '#FFB073'}} />
                  <span>School Crisis Management Counselling</span>
                </span>
              </div>
              <div className={styles.subDescription}>
                <span className={styles.awardItem}>
                  <LordIcon src="https://cdn.lordicon.com/djpzqlgv.json" trigger="hover" size={16} colors={{primary: '#FFB073', secondary: '#FFB073'}} />
                  <span>School Bullying & Truancy Counselling</span>
                </span>
              </div>
              <Button size='small' outline={true} className={styles.learnMoreButton} label='Learn More' onClick={handleOpenMore}/>
            </div>
            <div className={styles.bookImageView}>
              <div className={styles.availableImage}>
                <img src={available} alt='available now'/>
              </div>
            </div>
          </div>
        </div>}
      </div>
      <div className={styles.right}>
        <div className={styles.rightContent} style={{height: isRegistration ? 'calc(100vh - 100px' : ''}}>
          <img className={styles.logo} src={logo} alt="Logo"/>
          <div className={styles.titleView}>{title}</div>
          {typeof children === 'function' ? children() :
            <form className={styles.formClass} onSubmit={onSubmit}>
              {children}
            </form>
          }
        </div>
      </div>
      {!isRegistration && <div className={styles.footerBar}></div>}
    </div>
  );
}

export default NewAuthPageLayout;
